import React, { useState, useEffect } from "react";

const DimensionsCellEditor = (props) => {
    const { value, onValueChange } = props;
    const [length, setLength] = useState(value?.length || "");
    const [height, setHeight] = useState(value?.height || "");

    useEffect(() => {
        onValueChange({ length, height });
    }, [onValueChange, length, height]);

    const onBlur = () => {
        //props.stopEditing();
    };

    return (
        <div>
          <div class="double-editor-div-1">
              <input

                  className="double-editor-input"
                  type="text"
                  value={length}
                  onChange={(e) => setLength(e.target.value)}
                  onBlur={onBlur}
                  autoFocus
              />
          </div>
          <div class="double-editor-div-2">
              <input
                  id="double-editor-input-2"
                  className="double-editor-input"
                  type="text"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  onBlur={onBlur}
              />
          </div>
        </div>
    );
};

export default DimensionsCellEditor;
